function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 5.393c0 .837.602 1.57 1.305 1.57.603 0 1.055-.314 1.325-.867.11-.224.081-.442-.078-.554-.23-.161-.477-.34-.544-.725-.12-.685.553-1.57 1.406-2.2.854-.627 2.008-1.151 2.61-1.308.558-.145.955-.052 1.005.21.05.261-.05.575-.853.837-.804.262-1.456.576-2.059.995-.904.628-1.105 1.1-.954 1.413.13.27.542.31 1.054 0A18.087 18.087 0 0 1 6.283 3.7c.494-.224.936-.425 1.399-.715.727-.455 1-.942.954-1.623C8.586.628 7.883 0 6.929 0 4.117 0 0 2.618 0 5.393zm4.519.261c-1.004.471-1.506.995-1.506 1.937 0 .89.703 1.728 1.958 1.728 1.205 0 3.263-1.204 3.916-2.566.143-.298-.163-.543-.351-.418-1.105.733-1.908 1.204-3.013 1.518-.46.13-.737-.008-.853-.21-.151-.261-.054-.636.452-.837.222-.089.44-.171.655-.253.805-.306 1.599-.607 2.658-1.213.94-.538 1.406-.995 1.707-1.414.026-.035.048-.069.068-.099.064-.098.106-.163.183-.163.1 0 .302.315.302.629 0 .47-.05.785-.352 1.518-.09.22-.227.455-.373.707-.339.585-.731 1.263-.731 2.068 0 .942.803 1.414 1.305 1.414a.98.98 0 0 0 .653-.21.325.325 0 0 0 0-.523c-.302-.21-.452-.576-.452-1.048 0-.412.215-.824.467-1.306C11.57 6.23 12 5.406 12 4.24c0-1.518-1.255-2.88-2.109-3.036-.197-.037-.351.157-.301.314.05.157.107.409.05.733-.1.576-.545 1.109-1.406 1.675-.651.43-1.69.865-2.595 1.243-.42.176-.81.34-1.12.485z",
  fill: "url(#se34sovvaa)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "se34sovvaa",
  x1: -4.241,
  y1: 4.051,
  x2: 3.44,
  y2: 15.428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BD69D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.558,
  stopColor: "#30BEEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3A79E6"
})));
function SvgSensiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensiaLogo);
export default __webpack_public_path__ + "static/media/SensiaLogo.cc5b6c37d37afb727388d584f6936f5b.svg";
export { ForwardRef as ReactComponent };